export enum ConsumptionPlanType {
  Usual = 0,
  Low = 1,
  Vacation = 2,
  High = 3,
}
